import React from "react";

const IconCart = props => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M9.33334 24C7.86668 24 6.68001 25.2 6.68001 26.6667C6.68001 28.1333 7.86668 29.3333 9.33334 29.3333C10.8 29.3333 12 28.1333 12 26.6667C12 25.2 10.8 24 9.33334 24ZM1.33334 2.66666V5.33332H4.00001L8.80001 15.4533L7.00001 18.72C6.78668 19.0933 6.66668 19.5333 6.66668 20C6.66668 21.4667 7.86668 22.6667 9.33334 22.6667H25.3333V20H9.89334C9.70668 20 9.56001 19.8533 9.56001 19.6667L9.60001 19.5067L10.8 17.3333H20.7333C21.7333 17.3333 22.6133 16.7867 23.0667 15.96L27.84 7.30666C27.9467 7.11999 28 6.89332 28 6.66666C28 5.93332 27.4 5.33332 26.6667 5.33332H6.94668L5.69334 2.66666H1.33334ZM22.6667 24C21.2 24 20.0133 25.2 20.0133 26.6667C20.0133 28.1333 21.2 29.3333 22.6667 29.3333C24.1333 29.3333 25.3333 28.1333 25.3333 26.6667C25.3333 25.2 24.1333 24 22.6667 24Z"
      fill="black"
    />
  </svg>
);
export default IconCart;
